module.exports = __webpack_public_path__ + "img/bagels_pre_bake.90c2a793.jpg";